'use client';

import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
function createOptionalContext() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var Context = createContext(initialValue);
  var useOptionalContext = function useOptionalContext() {
    return useContext(Context);
  };
  var Provider = function Provider(_ref) {
    var children = _ref.children,
      value = _ref.value;
    return /* @__PURE__ */jsx(Context.Provider, {
      value: value,
      children: children
    });
  };
  return [Provider, useOptionalContext];
}
export { createOptionalContext };